<template>
    <v-container fluid fill-height>
        <Headful title="Account aanvragen voor scholen"></Headful>
        <Header
            color="white"
            show-logo
            :dark="false"
            show-back-button
            extended
        ></Header>
        <v-layout align-center class="mt-5 mb-5">
            <v-flex>
                <v-form ref="form" @submit.prevent="submit" class="px-5" :disabled="submitting || success">
                    <v-card class="elevation-0">
                        <v-card-text class="pa-7">
                            <h1 class="text-h5 mb-5 text-center text--success">Account aanvragen voor scholen</h1>
                            <div v-if="!success">
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="E-mail contactpersoon" v-model="registration.email" :rules="[requiredRule, emailRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Naam contactpersoon" v-model="registration.name" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Naam school/bestuur" v-model="registration.school" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                                    label="Functie contactpersoon" v-model="registration.function" :rules="[requiredRule]"
                                ></v-text-field>
                                <v-btn type="submit" color="primary" rounded :loading="submitting" :disabled="submitting" block class="mb-2 elevation-0">Verzenden</v-btn>
                            </div>
                            <v-alert v-else color="success">Bedankt voor het aanvragen van een account voor POrtaal. Je ontvangt zo snel mogelijk bericht van ons!</v-alert>
                            <v-btn v-if="!success" :to="{name: 'SignIn'}" block outlined rounded color="secondary" class="elevation-0">Terug naar inloggen</v-btn>
                        </v-card-text>
                    </v-card>
                </v-form>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";
import apiClient from "@/api/apiClient";

const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "RegisterSchool",
    components: {
        Headful,
        Header
    },
    data: () => ({
        submitting: false,
        submitted: false,
        success: false,
        registration: {
            school: null,
            name: null,
            function: null,
            email: null,
        },
        requiredRule: (value) => !!value || "Dit veld is verplicht.",
        emailRule: (value) => !!(!value || (!!value && value.match(emailRegex))) || "Ongeldig e-mailadres.",
    }),
    methods: {
        submit () {
            this.submitted = true;

            // Check if form is valid
            if (!this.$refs.form.validate() || this.submitting) {
                return;
            }

            this.submitting = true;

            const formData = new FormData();
            Object.keys(this.registration).forEach(key => {
                if (this.registration[key]) {
                    formData.append(key, key === 'facetChoices' ? JSON.stringify(this.registration[key]) : this.registration[key]);
                }
            });

            // Submit
            apiClient.post('/school-registreren', formData).then(() => {
                // Success
                this.success = true;
            }).catch((e) => {
                console.error(e);
                return this.$store.dispatch('showSnackbar', { color: 'error', text: 'Ongeldige gegevens, controleer de invoer' });
            }).finally(() => {
                this.submitting = false;
            });
        },
    },
}
</script>

<style scoped>

</style>
